import { ReactComponent as CardLogo } from 'assets/images/paymentMethods/card.svg';
import { ReactComponent as PaypalLogo } from 'assets/images/paymentMethods/paypal.svg';

export const logos = {
  card: CardLogo,
  paypal: PaypalLogo
};

export default logos;
